import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { Image } from '@fluentui/react-northstar';
import { iconAssets } from '../assets/theme/theme';

import '@djthoms/pretty-checkbox';
import '../styles/SendNotification.css';

const SendNotification = () => {

  const [clientName, setClientName] = useState([]);

  let { id } = useParams();

  useEffect(() => {
    setClientName(localStorage.getItem('clientName'));
  }, []);

  return (
    <div>
      <div className='row p-0 m-0 w-100'>
        <div className='col-auto px-2'>
          <Link to="/platform-dashboard"><button className='breadcrumbs-button-outline'>Dashboard</button></Link>
        </div>
        <div className='col-auto px-2'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to={`/view-client/${id}`}><button className='breadcrumbs-button-outline'>{clientName}</button></Link>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <button className='breadcrumbs-button'>Send Notification</button>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to={`/view-client/${id}/users`}><button className='breadcrumbs-button-outline'>Manage Users</button></Link>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to={`/view-client/${id}/skills`}><button className='breadcrumbs-button-outline'>Manage Skills</button></Link>
        </div>
      </div>
      <div className='row p-0 m-0 w-100 mt-5'>
        <div className='col-md-5 px-5'>
          <div className='row p-0 m-0 w-100'>
            <div className='col-auto ps-0'>
              <Image src={iconAssets.group} alt="" className="group-icon" />
            </div>
            <div className='col pe-0 d-flex align-items-center'>
              <div className='header-title text-center w-100 py-1'>Group</div>
            </div>
          </div>
          <div className='row p-0 m-0 w-100'>
            <div className='col-auto ps-0'>
              <div className='left-empty-space'></div>
            </div>
            <div className='col pe-0'>
              {/* <div className='search-user position-relative mt-4'>
                <input type="text" placeholder='Search user'/>
                <Image src={iconAssets.search} alt="" className="search-icon" />
              </div> */}
              <div className='select-bg'>

              </div>
            </div>
          </div>
        </div>
        <div className='col-md-7 px-5'>
          <div className='row p-0 m-0 w-100'>
            <div className='col-auto ps-0'>
              <Image src={iconAssets.subject} alt="" className="subject-icon" />
            </div>
            <div className='col pe-0 d-flex align-items-center'>
              <div className='header-title text-center w-100 py-1'>Subject</div>
            </div>
          </div>
          <div className='row p-0 m-0 w-100 mt-2'>
            <div className='col-auto ps-0'>
              <div className='empty-space'></div>
            </div>
            <div className='col px-0 mt-2'>
              <textarea className='w-100 notification-textarea' rows="2" placeholder='Enter your subject up to a maximum of 100 characters.'></textarea>
            </div>
          </div>

          <div className='row p-0 m-0 w-100 mt-4'>
            <div className='col-auto ps-0'>
              <Image src={iconAssets.message} alt="" className="message-icon" />
            </div>
            <div className='col pe-0 d-flex align-items-center'>
              <div className='header-title text-center w-100 py-1'>Notification Message</div>
            </div>
          </div>
          <div className='row p-0 m-0 w-100 mt-2'>
            <div className='col-auto ps-0'>
              <div className='empty-space'></div>
            </div>
            <div className='col px-0 mt-2'>
              <textarea className='w-100 notification-textarea' rows="8" placeholder='Enter your message up to a maximum of 300 characters.'></textarea>
            </div>
          </div>
          <div className='row p-0 m-0 w-100 mt-5'>
            <div className='col-6 d-flex justify-content-end'>
              <button className='send-notification-action-button row m-0 p-2 px-4'>
                <div className='col-auto p-0 d-flex align-items-center'>
                  <Image src={iconAssets.reset} alt="" className="reset-icon me-2" />
                </div>
                <div className='col p-0'>
                  Reset
                </div>
              </button>
            </div>
            <div className='col-6'>
              <button className='send-notification-action-button row m-0 p-2 px-4'>
                <div className='col-auto p-0 d-flex align-items-center'>
                  <Image src={iconAssets.send} alt="" className="send-icon me-2" />
                </div>
                <div className='col p-0'>
                  Send
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SendNotification